import React, { useState } from "react";
import { toast } from "sonner";
import { Link2, Eye, Ticket, QrCode } from "lucide-react";
import { Button } from "./components/ui/button";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger,
} from "./components/ui/dropdown-menu";
import { EventQrDialog } from "./EventQrDialog";

export const eventShareUrl = (eventId, action) =>
  `${window.location.origin}/?tab=events&event=${eventId}&action=${action}`;

const copyText = async (text) => {
  try {
    await navigator.clipboard.writeText(text);
  } catch {
    const ta = document.createElement("textarea");
    ta.value = text;
    document.body.appendChild(ta);
    ta.select();
    document.execCommand("copy");
    document.body.removeChild(ta);
  }
};

/** Admin-only: copy the external view / booking link of an event, or show its QR code. */
export const CopyEventLinkButton = ({ event, withLabel = false }) => {
  const [qrOpen, setQrOpen] = useState(false);
  const copy = async (action) => {
    await copyText(eventShareUrl(event.id, action));
    toast.success(action === "book" ? "Booking link copied" : "View link copied", {
      description: event.status === "draft" ? "This event is a draft: members can open the link once it is published." : undefined,
    });
  };

  return (
    <>
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          size="sm"
          variant={withLabel ? "outline" : "ghost"}
          title="Copy event link"
          data-testid={`copy-event-link-btn-${event.id}`}
        >
          <Link2 className={`h-4 w-4 ${withLabel ? "mr-1" : ""}`} />
          {withLabel && "Copy link"}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuLabel className="text-xs text-slate-500">Link for an external website</DropdownMenuLabel>
        <DropdownMenuItem onClick={() => copy("view")} data-testid={`copy-event-view-link-${event.id}`}>
          <Eye className="h-4 w-4 mr-2" /> Copy view link
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => copy("book")} data-testid={`copy-event-book-link-${event.id}`}>
          <Ticket className="h-4 w-4 mr-2" /> Copy booking link
        </DropdownMenuItem>
        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={() => setQrOpen(true)} data-testid={`show-event-qr-${event.id}`}>
          <QrCode className="h-4 w-4 mr-2" /> QR code for posters
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
    {qrOpen && <EventQrDialog event={event} open={qrOpen} onOpenChange={setQrOpen} />}
    </>
  );
};
